import { enumToText } from "@/utils/enums";
import { Anchor, Button, Checkbox, Input, Stack } from "@mantine/core";
import { useState } from "react";

export const EndwiseMultiSelect = ({
  label,
  get,
  set,
  defaultValue,
  disabled = false,
}: {
  label?: string;
  get: () => string[];
  set: (v: string[]) => void;
  defaultValue: string[];
  disabled?: boolean;
}) => {
  const [expanded, setExpanded] = useState(false);
  const defaultSize = 5;
  return (
    <Input.Wrapper label={label ?? undefined} mt={"5px"}>
      {defaultValue.length > 3 && (
        <Button
          size="xs"
          ml="sm"
          variant={"outline"}
          onClick={() =>
            set(get().length === defaultValue.length ? [] : defaultValue)
          }
        >
          Toggle All
        </Button>
      )}

      <Checkbox.Group
        value={get()}
        onChange={(v) => {
          set(v);
        }}
      >
        <Stack>
          {defaultValue
            .slice(0, expanded ? defaultValue.length : defaultSize)
            .map((type) => {
              return (
                <Checkbox
                  key={type}
                  label={enumToText(type)}
                  value={type}
                  disabled={disabled}
                />
              );
            })}
        </Stack>
      </Checkbox.Group>
      {defaultValue.length > defaultSize && (
        <>
          {!expanded && (
            <Anchor size="sm" mt="xs" onClick={() => setExpanded(true)}>
              Show More
            </Anchor>
          )}
          {expanded && (
            <Anchor size="sm" mt="xs" onClick={() => setExpanded(false)}>
              Show Less
            </Anchor>
          )}
        </>
      )}
    </Input.Wrapper>
  );
};
